import { render, staticRenderFns } from "./FrequencyEdit.vue?vue&type=template&id=31b4ed1d&scoped=true"
import script from "./FrequencyEdit.vue?vue&type=script&lang=js"
export * from "./FrequencyEdit.vue?vue&type=script&lang=js"
import style0 from "./FrequencyEdit.vue?vue&type=style&index=0&id=31b4ed1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4ed1d",
  null
  
)

export default component.exports